import { createSlice } from '@reduxjs/toolkit';

const LOCAL_KEY = 'routes_json';

function loadRoutes() {
  const json = localStorage.getItem(LOCAL_KEY);
  let routes;
  if (json) {
    try {
      routes = JSON.parse(json);
    } catch {
      routes = [];
    }
  } else {
    routes = [];
  }
  return routes;
}

function saveRoutes(routes) {
  localStorage.setItem(LOCAL_KEY, JSON.stringify(routes));
}

const initialState = {
  routes: loadRoutes(),
  filtered: loadRoutes(),
};

const routesSlice = createSlice({
  name: 'routes',
  initialState,
  reducers: {
    addRoute(state, action) {
      state.routes.push(action.payload);
      state.filtered = state.routes;
      saveRoutes(state.routes);
    },
    editRoute(state, action) {
      const idx = state.routes.findIndex(r => r.id === action.payload.id);
      if (idx !== -1) {
        state.routes[idx] = action.payload;
        state.filtered = state.routes;
        saveRoutes(state.routes);
      }
    },
    removeRoute(state, action) {
      state.routes = state.routes.filter(r => r.id !== action.payload);
      state.filtered = state.routes;
      saveRoutes(state.routes);
    },
    assignClientsToRoute(state, action) {
      const { routeId, clients } = action.payload; // clients: array of clientIds
      const route = state.routes.find(r => r.id === routeId);
      if (route) {
        route.clients = clients;
        saveRoutes(state.routes);
      }
    },
  },
});

export const { addRoute, editRoute, removeRoute, assignClientsToRoute } = routesSlice.actions;
export default routesSlice.reducer; 